/**
 * @generated SignedSource<<78f6c187ef219d1874431be828ce0d93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIntegrationTurnpikeSize = "TWO_X_ONE" | "TWO_X_TWO";
export type WidgetNoteSize = "TWO_X_ONE" | "TWO_X_TWO";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type WidgetTaskSingleSize = "ONE_X_ONE" | "TWO_X_ONE";
export type WidgetWeatherSize = "ONE_X_ONE" | "TWO_X_ONE";
export type WidgetPositionInput = {
  setCalendarOverviewPositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setCalendarWidgets?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setEmployeeLeavePositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setEmployeeRoleOverviewPositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setEmployeeSchedulePositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setFilePositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setIntegrationFlourishPraisePositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setIntegrationIpoolPositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setIntegrationPushAppyPositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setIntegrationTurnpikePositions?: ReadonlyArray<WidgetIntegrationTurnpikeSizePositionInput> | null;
  setIssueOverviewPositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setIssueSummaryPositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setKPIPositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setListPositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setNewsfeedPositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setNotePositions?: ReadonlyArray<WidgetNotePositionInput> | null;
  setRoutineOverviewPositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setRoutinePositivePercentagePositions?: ReadonlyArray<WidgetRoutinePositivePercentagePositionInput> | null;
  setSignalOverviewPositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setSpacePositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setTablePositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setTaskCollectionPositions?: ReadonlyArray<WidgetTaskCollectionPositionInput> | null;
  setTaskSinglePositions?: ReadonlyArray<WidgetTaskSinglePositionInput> | null;
  setTeamSchedulePositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setTodoOverviewPositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setTodoSummaryPositions?: ReadonlyArray<WidgetOverviewPositionInput> | null;
  setWeatherPositions?: ReadonlyArray<WidgetWeatherPositionInput> | null;
};
export type WidgetOverviewPositionInput = {
  positionX: number;
  positionY: number;
  setSize?: WidgetOverviewSize | null;
  widgetId: string;
};
export type WidgetIntegrationTurnpikeSizePositionInput = {
  positionX: number;
  positionY: number;
  setSize?: WidgetIntegrationTurnpikeSize | null;
  widgetId: string;
};
export type WidgetNotePositionInput = {
  positionX: number;
  positionY: number;
  setSize?: WidgetNoteSize | null;
  widgetId: string;
};
export type WidgetRoutinePositivePercentagePositionInput = {
  positionX: number;
  positionY: number;
  widgetId: string;
};
export type WidgetTaskCollectionPositionInput = {
  positionX: number;
  positionY: number;
  widgetId: string;
};
export type WidgetTaskSinglePositionInput = {
  positionX: number;
  positionY: number;
  setSize?: WidgetTaskSingleSize | null;
  widgetId: string;
};
export type WidgetWeatherPositionInput = {
  positionX: number;
  positionY: number;
  setSize?: WidgetWeatherSize | null;
  widgetId: string;
};
export type useRearangeWidgetsMutation$variables = {
  positions: WidgetPositionInput;
  storecastId: string;
};
export type useRearangeWidgetsMutation$data = {
  readonly dashboard: {
    readonly setWidgetPositions: {
      readonly id: string;
      readonly widgets: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"useWidgetToPos_widget">;
      } | null>;
    };
  };
};
export type useRearangeWidgetsMutation = {
  response: useRearangeWidgetsMutation$data;
  variables: useRearangeWidgetsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "positions"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "dashboardId",
    "variableName": "storecastId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "positions",
    "variableName": "positions"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionX",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionY",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useRearangeWidgetsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DashboardMutation",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Dashboard",
            "kind": "LinkedField",
            "name": "setWidgetPositions",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useWidgetToPos_widget"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useRearangeWidgetsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DashboardMutation",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Dashboard",
            "kind": "LinkedField",
            "name": "setWidgetPositions",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isWidget"
                  },
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "overviewSize",
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetOverview",
                    "abstractKey": "__isWidgetOverview"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "noteSize",
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetNote",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "taskSingleSize",
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetTaskSingle",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "size",
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetWeather",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "turnpikeSize",
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetIntegrationTurnpike",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "subWidgets",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "height",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetSpace",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "45981f875b67b1e8c7bba6cc0a1d110e",
    "id": null,
    "metadata": {},
    "name": "useRearangeWidgetsMutation",
    "operationKind": "mutation",
    "text": "mutation useRearangeWidgetsMutation(\n  $storecastId: ID!\n  $positions: WidgetPositionInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    setWidgetPositions(positions: $positions) {\n      id\n      widgets {\n        __typename\n        ...useWidgetToPos_widget\n        id\n      }\n    }\n  }\n}\n\nfragment useWidgetToPos_widget on Widget {\n  __isWidget: __typename\n  id\n  positionX\n  positionY\n  ... on WidgetOverview {\n    __isWidgetOverview: __typename\n    overviewSize\n  }\n  ... on WidgetNote {\n    noteSize\n  }\n  ... on WidgetTaskSingle {\n    taskSingleSize\n  }\n  ... on WidgetWeather {\n    size\n  }\n  ... on WidgetIntegrationTurnpike {\n    turnpikeSize\n  }\n  ... on WidgetSpace {\n    subWidgets {\n      __typename\n      id\n      positionX\n      positionY\n      height\n    }\n  }\n  __typename\n}\n"
  }
};
})();

(node as any).hash = "ed8dc43dad777deb3e6aa6fffa0b7cce";

export default node;
